// extracted by mini-css-extract-plugin
export default {"AdditionalInformation":"_AdditionalInformation--A_hyR","RecipientDetails":"_RecipientDetails--qcOO6","RecipientEmail":"_RecipientEmail--bbz72"};